import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0116f66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Solicitudes Pendientes", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ir a amigos", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "userMessage" }
const _hoisted_10 = { class: "image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Sin solicitudes pendientes.")
], -1))
const _hoisted_17 = [
  _hoisted_16
]

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref, onMounted ,Ref} from 'vue'
import { useAuth } from '@/store/useAuth'
import AddFriend from '@/components/widgets/AddFriend.vue'
import FriendshipService from '@/services/FriendshipService'
import { Toast } from '@/interfaces/ToastInterface'
import { useToast } from '@/store/useToast'
import RequestI from '@/interfaces/RequestInterface'


export default /*#__PURE__*/_defineComponent({
  __name: 'FriendRequestView',
  setup(__props) {

const loading = ref(true)
const store = useAuth()
const showAddFriend = ref(false)
const requests:Ref<RequestI[]> = ref([])
const service = new FriendshipService()
const toast = useToast()


onMounted(async () => {
    if (!store.token) {
        loading.value = false
        return
    }
    loading.value = true
    requests.value = await service.listPendingRequests(store.token)
    loading.value = false
})



const accept = async (id:string | undefined) => {
    loading.value = true
    if(store.token != null){
    const response = await service.acceptFriendshipRequest(store.token, id);
    toast.showToast(response.message, Toast.INFO)
    setTimeout(function () { toast.hideToast() }, 4000);
    requests.value = await service.listPendingRequests(store.token)
}
    loading.value = false
}


const decline = async (id:string | undefined) => {
    loading.value = true
    if(store.token != null){
    const response = await service.declineFriendshipRequest(store.token, id);
    toast.showToast(response.message, Toast.INFO)
    setTimeout(function () { toast.hideToast() }, 4000);
    requests.value = await service.listPendingRequests(store.token)
    }
    loading.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (showAddFriend.value)
              ? (_openBlock(), _createBlock(AddFriend, {
                  key: 0,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (showAddFriend.value=false))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createVNode(_component_RouterLink, { to: {name:'friends'} }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "friend",
                    style: {"float":"left"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showAddFriend.value = true))
                  }, _hoisted_7)
                ]),
                _: 1
              })
            ]),
            (requests.value.length >0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value, (request) => {
                    return (_openBlock(), _createElementBlock("li", {
                      style: {"margin":"2px"},
                      class: "liMessages",
                      key: request.id
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (request.sender?.profile_picture_uri)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: request.sender?.profile_picture_uri,
                                width: "128"
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(request.sender?.name?.substring(0,2)), 1))
                        ])
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, _toDisplayString(request.sender?.name), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          style: {"float":"right"},
                          class: "glass red",
                          onClick: ($event: any) => (decline(request.id))
                        }, [
                          _createVNode(_component_v_icon, {
                            name: "si-adblock",
                            class: "icon",
                            hover: "true",
                            animation: "wrench",
                            fill: "white",
                            style: {"margin-right":"5px"}
                          }),
                          _createTextVNode("Rechazar")
                        ], 8, _hoisted_13),
                        _createElementVNode("button", {
                          style: {"float":"right"},
                          class: "glass",
                          onClick: ($event: any) => (accept(request.id))
                        }, [
                          _createVNode(_component_v_icon, {
                            name: "io-person-add-sharp",
                            class: "icon",
                            hover: "true",
                            animation: "wrench",
                            fill: "white",
                            style: {"margin-right":"5px"}
                          }),
                          _createTextVNode("Aceptar")
                        ], 8, _hoisted_14)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          ]))
    ]),
    _: 1
  }))
}
}

})